<template>
  <vs-navbar class="accessibility">
     <vs-popup v-if="!isDesktop" :title="$t('ACCESSIBILITY').Accessibility" :active.sync="displayAccessibilityModal">
      <vx-card>
            <div class="flex">
                <vs-button
                color="primary"
                type="line"
                @click.stop="$emit('update-zoom-compact')"
                :class="{'selected': isZoomCompact}"
                >A-</vs-button>
                <vs-button
                color="primary"
                type="line"
                @click.stop="$emit('update-zoom-default')"
                :class="{'selected': isZoomDefault}"
                >{{ $t('ACCESSIBILITY').Normal }}</vs-button>
                <vs-button
                color="primary"
                type="line"
                @click.stop="$emit('update-zoom-big')"
                :class="{'selected': isZoomBig}"
                >A+</vs-button>
            </div>
            <div>
                <vs-button
                color="primary"
                type="line"
                @click.stop="$emit('update-contrast')"
                icon-pack="feather"
                :icon="contrastIcon"
                class="w-full cursor-pointer"
                >{{currentThemeName}}</vs-button
                >
            </div>
        </vx-card>
    </vs-popup>
    <!-- <div slot="title">
        <vs-navbar-title> </vs-navbar-title>
    </div> -->
    <vs-navbar-item>
        <vs-dropdown vs-custom-content class="flex items-center cursor-pointer">
            <vs-button class="flex items-center cursor-pointer" type="line" color="primary">
                {{ $t('ACCESSIBILITY').Accessibility }}
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1"/>
            </vs-button>

            <vs-dropdown-menu class="dropdown-login dropdown-accessibility">
                <vx-card>
                    <div class="flex">
                        <vs-button
                        color="primary"
                        type="line"
                        @click.stop="$emit('update-zoom-compact')"
                        :class="{'selected': isZoomCompact}"
                        >A-</vs-button>
                        <vs-button
                        color="primary"
                        type="line"
                        @click.stop="$emit('update-zoom-default')"
                        :class="{'selected': isZoomDefault}"
                        >{{ $t('ACCESSIBILITY').Normal }}</vs-button>
                        <vs-button
                        color="primary"
                        type="line"
                        @click.stop="$emit('update-zoom-big')"
                        :class="{'selected': isZoomBig}"
                        >A+</vs-button>
                    </div>
                    <div>
                        <vs-button
                        color="primary"
                        type="line"
                        @click.stop="$emit('update-contrast')"
                        icon-pack="feather"
                        :icon="contrastIcon"
                        class="w-full cursor-pointer"
                        >{{currentThemeName}}</vs-button
                        >
                    </div>
                    <div class="flex" v-if="isDesktop && displayAlign">
                        <vs-button
                        color="primary"
                        type="line"
                        @click.stop="$emit('update-format-align-left')"
                        icon-pack="feather"
                        icon="icon-align-left"
                        class="w-full"
                        :class="{'selected': isFormatAlignLeft}"
                        ></vs-button                    >
                        <vs-button
                        color="primary"
                        type="line"
                        icon-pack="feather"
                        icon="icon-align-center"
                        @click.stop="$emit('update-format-align-center')"
                        class="w-full"
                        :class="{'selected': isFormatAlignCenter}"
                        ></vs-button>
                        <vs-button
                        color="primary"
                        type="line"
                        @click.stop="$emit('update-format-align-right')"
                        icon-pack="feather"
                        icon="icon-align-right"
                        class="w-full"
                        :class="{'selected': isFormatAlignRight}"
                        ></vs-button>
                        <!-- <vs-button
                        color="primary"
                        type="line"
                        @click.stop="updateZoomBig()"
                        icon-pack="feather"
                        icon="icon-chevron-down"
                        >Grande</vs-button
                        > -->
                    </div>
                </vx-card>
            </vs-dropdown-menu>
        </vs-dropdown>
    </vs-navbar-item>

    <!-- <vs-navbar-item index="1">
    <vs-button
        color="primary"
        type="line"
        icon-pack="feather"
        icon="icon-share-2"
    >
        Compartilhar</vs-button
    >
    </vs-navbar-item> -->

    <vs-navbar-item index="2" v-if="canSpeechText">
        <!-- <vs-button
            color="primary"
            type="line"
            icon-pack="feather"
            icon="icon-play"
            v-if="canSpeechText"
            >Ouvir o texto</vs-button
        > -->
        <vs-button
            color="primary"
            type="line"
            icon-pack="feather"
            @click.stop="onSpeech(detail)"
            v-if="!isPlaying && showVolume"
            icon="icon-play"
            >{{ $t('ACCESSIBILITY').To_Hear }}
            <span
            color="primary"
            class="speach-btn"
            type="flat"
            size="small"
            @click.stop="$emit('update-rate-speed')"
            v-if="!isPlaying"
            >
            <span class="rateSpeech">{{ rateTextSpeechLabel }}</span>
            </span>
        </vs-button>

        <vs-button
            color="secondary"
            type="line"
            icon-pack="feather"
            icon="icon-pause"
            @click.stop="$emit('pause-speech-text')"
            v-if="isPlaying && showVolume"
            >{{ $t('ACCESSIBILITY').Pause_reading }}
            <span class="rateSpeechD">{{
            rateTextSpeechLabel
            }}</span></vs-button
        >

        <!-- <vs-button color="primary" @click="onSpeech(detail)" type="line" v-if="canSpeechText" class="speach-btn" -->

        <!-- <feather-icon v-if="isPlaying && showVolume" icon="Volume1Icon" class="cursor-pointer icon-down" @click="onSpeech(detail)"></feather-icon> -->
        <!-- <feather-icon
                v-if="isPlaying && showVolume"
                icon="PauseIcon"
                @click.stop="onPause()"
            ></feather-icon>
            <feather-icon
                v-if="!isPlaying && showVolume"
                icon="PlayIcon"
                @click.stop="onSpeech(detail)"
            ></feather-icon> -->
        <!-- <span v-if="showVolume">{{ $t("REPORT").Hear_Text }}</span> -->

        <!-- </vs-button> -->
        <!-- <vs-button
            color="primary"
            class="speach-btn"
            type="line"
            @click.stop="changeRateSpeech"
            v-if="!isPlaying"
            >
            <span>{{ rateTextSpeechLabel }}</span>
            </vs-button> -->
    </vs-navbar-item>
    <vs-navbar-item index="3" v-if="canDownloadFile">
        <vs-button
            color="primary"
            type="line"
            icon-pack="feather"
            icon="icon-download"
            @click.stop="$emit('download-file')"
            >{{ $t('ACCESSIBILITY').Appendix }}</vs-button
        >
        </vs-navbar-item>
    <!-- <vs-navbar-item index="4">
        <vs-dropdown class="cursor-pointer">
            <vs-button
            color="primary"
            type="line"
            icon-pack="feather"
            icon="icon-chevron-down"
            vs-trigger-click
            v-if="isFormatAlignLeft"
            >Leitura a esquerda</vs-button
            >
            <vs-button
            color="primary"
            type="line"
            icon-pack="feather"
            icon="icon-chevron-down"
            vs-trigger-click
            v-if="isFormatAlignCenter"
            >Leitura centralizado</vs-button
            >
            <vs-button
            color="primary"
            type="line"
            icon-pack="feather"
            icon="icon-chevron-down"
            vs-trigger-click
            v-if="isFormatAlignRight"
            >Leitura a direita</vs-button
            >
            <vs-dropdown-menu class="custom-dropdown-font-detail">
            <vs-dropdown-item
                @click.stop="updateFormatAlignLeft()"
                :class="{ 'selected': isFormatAlignLeft }"
                >Esquerda</vs-dropdown-item
            >
            <vs-dropdown-item
                @click.stop="updateFormatAlignCenter()"
                :class="{ 'selected': isFormatAlignCenter }"
                >Centralizado</vs-dropdown-item
            >
            <vs-dropdown-item
                @click.stop="updateFormatAlignRight()"
                :class="{ 'selected': isFormatAlignRight }"
                >Direita</vs-dropdown-item
            >
            </vs-dropdown-menu>
        </vs-dropdown>
    </vs-navbar-item> -->
    <!-- <vs-navbar-item index="4">
    
    </vs-navbar-item> -->
    </vs-navbar>
</template>

<script>
import AppConstants from '../../../appConstants';
export default {
    data() {
        return {
            displayAccessibilityModal: false
        }
    },
    props: {
        displayAlign: {
            type: Boolean,
            default: false
        },
        isDesktop: {
            type: Boolean,
            default: false
        },
        canSpeechText: {
            type: Boolean,
            default: false
        },
        isPlaying: {
            type: Boolean,
            default: false
        },
        canDownloadFile: {
            type: Boolean,
            default: false
        },
        showVolume: {
            type: String,
            default: ''
        },
        rateTextSpeechLabel: {
            type: String,
            default: ''
        },
        
    },
    computed: {
        currentThemeName() {
            if(this.$store.state.theme === AppConstants.THEME.DARK) {
            return this.$t('NAVBAR_DROPDOWN_MENU').Light_Theme;
            }
            return this.$t('NAVBAR_DROPDOWN_MENU').Dark_Theme;
        },
        currentTheme() {
            return this.$store.state.theme;
        },
        contrastIcon() {
            if (this.currentTheme == AppConstants.THEME.DARK) {
                return 'icon-sun';
            } 
            return 'icon-moon'
        },
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
        currentFormatAlignDetail() {
            return this.activeUserInfo.formatAlignDetail;
        },
        currentZoomDetail() {
            return this.activeUserInfo.zoomDetail;
        },
        isZoomCompact() {
            return this.currentZoomDetail === AppConstants.ZOOM.COMPACT;
        },
        isZoomDefault() {
            return this.currentZoomDetail === AppConstants.ZOOM.DEFAULT;
        },
        isZoomMedium() {
            return this.currentZoomDetail === AppConstants.ZOOM.MEDIUM;
        },
        isZoomBig() {
            return this.currentZoomDetail === AppConstants.ZOOM.BIG;
        },
        isFormatAlignLeft() {
            return this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.LEFT;
        },
        isFormatAlignCenter() {
            return this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.CENTER;
        },
        isFormatAlignRight() {
            return this.currentFormatAlignDetail === AppConstants.DETAIL_FORMAT_ALIGN.RIGHT;
        },
    },
    methods: {
        openAccessibilityModal(event) {
            console.log('openAccessibilityModal', event)
            this.displayAccessibilityModal = !this.displayAccessibilityModal;
        }
    }
}
</script>

<style>

</style>